import { VSF_LOCALE_COOKIE, VSF_CURRENCY_COOKIE } from '@vue-storefront/core';
/* eslint complexity: ["error", 30] */
export default async (context) => {
  // const { app, route } = context;
  // const { app, $vsf, $gtm, req, route, $cookies, error } = context;
  // if (process.server) {
  //   app.$xreq = {
  //     host: req?.headers.host,
  //     cookie: req?.headers.cookie
  //   };
  // } else {
  //   app.$xreq = {
  //     host: window.location.host,
  //     cookie: document.cookie
  //   };
  // }
  // console.log("-------i18n--shopConfigAll----------", app.$storeConfig);

  // app.$storeConfig = await $vsf.$xbuy.api.shopConfigAll({ host: app.$xreq.host, cache_key: process.env.clear_cache_uniqueKey });
  // if (app.$storeConfig.error === 'no_shop_find') {
  //   error({ statusCode: 403, message: 'Domain not found' });
  //   return;
  // }

  // //console.log('context', context?.redirect);
  // if (app.$storeConfig?.mall_registry_settings) {
  //   app.$storeConfig.mall_registry_settings = JSON.parse(app.$storeConfig.mall_registry_settings);
  // } else {
  //   app.$storeConfig.mall_registry_settings = {
  //     "email": {
  //       "enable": true,
  //       "verify": false
  //     },
  //     "phone": {
  //       "enable": false,
  //       "verify": false
  //     }
  //   };
  // }
  // const { data } = await $vsf.$xbuy.api.shopView();
  // const viewList = data?.list;

  // //通过url获取语言
  // var defaultView = viewList?.find((item) => {
  //   return (route.path.indexOf("/" + item.lang + "/") > -1);
  // });
  // if (!defaultView) {
  //   defaultView = viewList?.find((item) => {
  //     return item.isDefault === 1;
  //   });
  // }
  // if ((route.path === '/' || route.path === '')) {
  //   return context.redirect(`/${defaultView.lang}${route.fullPath}`);
  // }
};
